import type { ComponentProps } from "react";

export function Profile(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 29 28"
			fill="none"
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M15.97 11.307a2 2 0 1 1-4.002 0 2 2 0 0 1 4.002 0Zm.663 2.711a3.8 3.8 0 1 0-5.282.045 6.067 6.067 0 0 0-3.936 5.68.9.9 0 0 0 1.8 0 4.265 4.265 0 0 1 4.265-4.264h1.147a4.265 4.265 0 0 1 4.265 4.264.9.9 0 0 0 1.8 0 6.067 6.067 0 0 0-4.059-5.725Z"
				clipRule="evenodd"
			/>
		</svg>
	);
}
